// EARTH CURVATURE as a client vertex transform (R5d flip precondition 1,
// APP_GROUNDM "Curvature"). PURE (no three): gmdecode.js geoArrays applies it
// to every GROUND-M vertex it emits (the worker's stitch and the main
// thread's alike), groundtree.js to the index y range and groundDrawn;
// scripts/check-curve.mjs pins it.
//
// The baked heights stay flat-earth truth (GM03 nodes, outer.py: "no earth
// curvature ... the reader's transform"). The drawn ground sinks by the
// refraction-corrected drop d^2 / (2 R_eff), d = the distance to the playable
// frame rect [0, 0, W, H] (game m) — bake.py _earth_drop, the curve ring.bin /
// horizon.bin carry baked in and ringref.js ringDrop undoes for the ring
// paint. Inside the frame d = 0 and a vertex keeps its height bit for bit (the
// player's ground, standing height and every frame gate untouched); a vertex
// shared by two nodes is the same xz in both, so the same drop (no crack).
//
//   curveOf(meta)   { frame, k: 1 / (2 R_eff) } from meta.bbox +
//                   meta.panorama.earth_r_eff_m; null for a world without a
//                   far field (no panorama: nothing drawn beyond the frame);
//                   a panorama without earth_r_eff_m throws
//   curveDrop(c, x, z)              the drop at (x, z) (0 with c null)
//   curveRange(c, x0, z0, x1, z1)   [min, max] drop over the box
export function curveOf(meta) {
  const p = meta.panorama;
  if (!p) return null;
  if (!(p.earth_r_eff_m > 0)) throw new Error('meta.panorama.earth_r_eff_m missing: the far field\'s curvature needs it');
  const bb = meta.bbox;
  return { frame: [0, 0, bb.e1 - bb.e0, bb.n1 - bb.n0], k: 0.5 / p.earth_r_eff_m };
}

export function curveDrop(c, x, z) {
  if (!c) return 0;
  const F = c.frame, dx = Math.max(F[0] - x, 0, x - F[2]), dz = Math.max(F[1] - z, 0, z - F[3]);
  return (dx * dx + dz * dz) * c.k;
}

export function curveRange(c, x0, z0, x1, z1) {
  if (!c) return [0, 0];
  const F = c.frame;
  // per axis the nearest / farthest distance to the frame's slab over [a0, a1]
  const ax = (a0, a1, f0, f1) => {
    const d = (a) => Math.max(f0 - a, 0, a - f1);
    return [a0 <= f1 && a1 >= f0 ? 0 : Math.min(d(a0), d(a1)), Math.max(d(a0), d(a1))];
  };
  const [xn, xf] = ax(x0, x1, F[0], F[2]), [zn, zf] = ax(z0, z1, F[1], F[3]);
  return [(xn * xn + zn * zn) * c.k, (xf * xf + zf * zf) * c.k];
}
